import { ChevronLeft, ChevronRight } from 'lucide-react'

export interface PaginationControlsProps {
  currentPage: number
  totalPages: number
  totalItems: number
  startIndex: number
  endIndex: number
  onPreviousPage: () => void
  onNextPage: () => void
  itemLabel?: string // Label para o item (ex: "pessoa", "usuário", "projeto")
}

export function PaginationControls({
  currentPage,
  totalPages,
  totalItems,
  startIndex,
  endIndex,
  onPreviousPage,
  onNextPage,
  itemLabel = 'item',
}: PaginationControlsProps) {
  // Só renderizar se houver mais de uma página
  if (totalPages <= 1) {
    return null
  }

  const startDisplay = startIndex + 1
  const endDisplay = Math.min(endIndex, totalItems)
  const itemLabelPlural = itemLabel.endsWith('a') ? `${itemLabel}s` : `${itemLabel}s`

  return (
    <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex items-center justify-between">
      <div className="text-sm text-gray-700">
        Mostrando {startDisplay} a {endDisplay} de {totalItems} {itemLabelPlural}
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={onPreviousPage}
          disabled={currentPage === 1}
          className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          title="Página anterior"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
        <span className="px-3 py-1 text-sm font-medium text-gray-700">
          {currentPage} / {totalPages}
        </span>
        <button
          onClick={onNextPage}
          disabled={currentPage === totalPages}
          className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          title="Próxima página"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}
